function getSchemaVersionFromDocument(document) {
    if (!document) {
        return null;
    }

    // Schema version can sometimes come back as string, but should always be an integer.
    const schemaVersion = parseInt(document.schemaVersion);

    if (isNaN(schemaVersion)) {
        throw new Error(`Invalid schemaVersion: "${document.schemaVersion}"`);
    }

    return schemaVersion;
}

export default getSchemaVersionFromDocument;
